"use strict";
(self["__LOADABLE_LOADED_CHUNKS__"] = self["__LOADABLE_LOADED_CHUNKS__"] || []).push([[2293],{

/***/ 18640:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(78364);
/* harmony import */ var device__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96934);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(59909);
/* harmony import */ var components_inputs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(30468);
/* harmony import */ var components_inputs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(34212);
/* harmony import */ var components_feedback__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10962);
/* harmony import */ var compositions_productCards_ProductCardDetailed_ProductCardDetailed__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(90437);
/* harmony import */ var compositions_productCards_ProductCardDetailedSkeleton_ProductCardDetailedSkeleton__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(32511);
/* harmony import */ var compositions_productCards_ProductCardSmall_ProductCardSmall__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(88589);
/* harmony import */ var compositions_productCards_ProductCardSmallSkeleton_ProductCardSmallSkeleton__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(80866);











const FetchMoreButtonProductList = (props)=>{
    const { className, products, buttonProps, fetchMore, totalCount, fetchSkeletonsAmount, fetchMoreButtonTitle, fetchMoreButtonStyle, excludeLabels, isFetching, withDetailedMobileCards, withoutLink, withRetailPrice } = props;
    const { isMobile } = (0,device__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    if (!isFetching && products && !products.length) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_feedback__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            className: isMobile ? "mt-48" : "mt-96"
        });
    }
    const MobileProductCard = withDetailedMobileCards ? compositions_productCards_ProductCardDetailed_ProductCardDetailed__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z : compositions_productCards_ProductCardSmall_ProductCardSmall__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z;
    const MobileProductCardSkeleton = withDetailedMobileCards ? compositions_productCards_ProductCardDetailedSkeleton_ProductCardDetailedSkeleton__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z : compositions_productCards_ProductCardSmallSkeleton_ProductCardSmallSkeleton__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z;
    const mobileGridColClass = withDetailedMobileCards ? "grid-cols-1" : "grid-cols-2";
    const rootClassName = (0,classnames__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(className, "grid grid-flow-dense items-stretch gap-16", isMobile ? mobileGridColClass : "grid-cols-3-center");
    const isFetchMoreButtonVisible = (products === null || products === void 0 ? void 0 : products.length) < totalCount;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: rootClassName,
                role: "list",
                children: [
                    Boolean(products === null || products === void 0 ? void 0 : products.length) && products.map((data)=>/*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement(isMobile ? MobileProductCard : compositions_productCards_ProductCardDetailed_ProductCardDetailed__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            key: data.id,
                            data,
                            withoutLink,
                            replaceRatingWithRetailPrice: withRetailPrice,
                            buttonProps,
                            excludeLabels
                        })),
                    isFetching && helpers__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z.range(1, fetchSkeletonsAmount).map((index)=>isMobile ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MobileProductCardSkeleton, {}, index) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(compositions_productCards_ProductCardDetailedSkeleton_ProductCardDetailedSkeleton__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {}, index))
                ]
            }),
            isFetchMoreButtonVisible && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "mt-32 text-center",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_inputs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                    title: fetchMoreButtonTitle || components_inputs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z.showMore,
                    size: 56,
                    style: fetchMoreButtonStyle || "secondary",
                    width: 320,
                    fullWidthOnMobile: true,
                    onClick: fetchMore,
                    "data-testid": "viewMoreButton"
                })
            })
        ]
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (FetchMoreButtonProductList);


/***/ }),

/***/ 12360:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ ProductCarousel_ProductCarousel)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
// EXTERNAL MODULE: ./src/helpers/primitives/array.ts
var array = __webpack_require__(59909);
// EXTERNAL MODULE: ./local_modules/device/useDevice.ts
var useDevice = __webpack_require__(96934);
// EXTERNAL MODULE: ./src/components/layout/ScrollableContainer/ScrollableContainer.tsx
var ScrollableContainer = __webpack_require__(90076);
// EXTERNAL MODULE: ./src/components/dataDisplay/Carousel/Carousel.tsx + 2 modules
var Carousel = __webpack_require__(51039);
// EXTERNAL MODULE: ./src/compositions/productCards/ProductCardSmall/ProductCardSmall.tsx
var ProductCardSmall = __webpack_require__(88589);
// EXTERNAL MODULE: ./src/compositions/productCards/ProductCardSmallSkeleton/ProductCardSmallSkeleton.tsx
var ProductCardSmallSkeleton = __webpack_require__(80866);
// EXTERNAL MODULE: ./src/compositions/productCards/ProductCardDetailed/ProductCardDetailed.tsx
var ProductCardDetailed = __webpack_require__(90437);
// EXTERNAL MODULE: ./src/compositions/productCards/ProductCardDetailedSkeleton/ProductCardDetailedSkeleton.tsx
var ProductCardDetailedSkeleton = __webpack_require__(32511);
;// CONCATENATED MODULE: ./src/compositions/productLists/ProductCarousel/ProductCarousel.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const ProductCarousel_module = ({"container":"MM0wFN","gridSmall":"JQNooT","carousel":"i6u9fe","gridDetailed":"G5176R"});
;// CONCATENATED MODULE: ./src/compositions/productLists/ProductCarousel/ProductCarousel.tsx












const ProductCarousel = (props)=>{
    const { className, desktopType = "small", products, excludeLabels, extraNode, isEcommerce, isFetching, withoutNotes, withoutLink, lazy, bgColorClassName, dataAttributes, recommenderStrategies } = props;
    const { isMobile } = (0,useDevice/* default */.Z)();
    const isTypeSmall = desktopType === "small";
    const [SkeletonComponent, ProductComponent, visibleNodeAmount] = isTypeSmall || isMobile ? [
        ProductCardSmallSkeleton/* default */.Z,
        ProductCardSmall/* default */.Z,
        6
    ] : [
        ProductCardDetailedSkeleton/* default */.Z,
        ProductCardDetailed/* default */.Z,
        3
    ];
    let itemsNode;
    if (isFetching) {
        itemsNode = array/* default */.Z.range(1, visibleNodeAmount).map((index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonComponent, {}, index));
    } else if (!(products === null || products === void 0 ? void 0 : products.length)) {
        return null;
    } else {
        itemsNode = products.map((data)=>{
            const { uid } = data;
            const strategyId = recommenderStrategies === null || recommenderStrategies === void 0 ? void 0 : recommenderStrategies[uid];
            const attributes = {};
            if (strategyId) {
                attributes["data-cnstrc-item"] = "recommendation";
                attributes["data-cnstrc-strategy-id"] = strategyId;
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductComponent, {
                className: "h-full",
                data: data,
                excludeLabels: excludeLabels,
                isEcommerce: isEcommerce,
                withoutNotes: withoutNotes,
                withoutLink: withoutLink,
                bgColorClassName: bgColorClassName,
                buttonProps: "buttonProps" in props ? props.buttonProps : {
                    withNonAuthRedirect: props.withNonAuthRedirect,
                    onClick: props.onProductButtonClick ? ()=>props.onProductButtonClick(data) : undefined,
                    metadata: props.metadata
                },
                lazy: lazy,
                dataAttributes: attributes
            }, data.id);
        });
    }
    if (isMobile) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ScrollableContainer/* default */.Z, {
            className: (0,clsx/* default */.Z)(ProductCarousel_module.container, "flex"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (0,clsx/* default */.Z)(className, ProductCarousel_module.gridSmall, "inline-grid grid-flow-col gap-16 py-16"),
                    ...dataAttributes,
                    children: itemsNode
                }),
                extraNode
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: itemsNode.length > visibleNodeAmount ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Carousel/* default */.Z, {
            className: ProductCarousel_module.carousel,
            withArrows: true,
            slidesToScroll: visibleNodeAmount,
            slidesToShow: visibleNodeAmount,
            dataAttributes: dataAttributes,
            children: itemsNode.map((child, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "h-full px-8",
                    children: child
                }, child.key || index))
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,clsx/* default */.Z)(className, isTypeSmall ? ProductCarousel_module.gridSmall : ProductCarousel_module.gridDetailed, "grid grid-flow-col justify-center gap-16"),
                ...dataAttributes,
                children: itemsNode
            })
        })
    });
};
/* harmony default export */ const ProductCarousel_ProductCarousel = (/*#__PURE__*/react.memo(ProductCarousel));


/***/ }),

/***/ 3249:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var device__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96934);
/* harmony import */ var intersection_observer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34886);
/* harmony import */ var modules_user__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40038);
/* harmony import */ var modules_products__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(91491);
/* harmony import */ var modules_products__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(32029);
/* harmony import */ var components_dataDisplay__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(78565);
/* harmony import */ var compositions_productLists_ProductCarousel_ProductCarousel__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(12360);








// workaround to add types checking to value and have defined keys
const asFeedConfig = (t)=>t;
const feedConfig = asFeedConfig({
    bestsellers: {
        input: {
            productsFeed: "BESTSELLERS_MAIN",
            filter: [
                {
                    type: "CATEGORY",
                    filterValueIdList: [
                        "bestsellers"
                    ]
                }
            ]
        },
        metadata: {
            placement: "Bestsellers"
        },
        excludeLabels: [
            "BESTSELLER"
        ]
    },
    newArrivals: {
        metadata: {
            placement: "New arrivals"
        },
        input: {
            productsFeed: "NEW_ARRIVALS",
            filter: [
                {
                    type: "CATEGORY",
                    filterValueIdList: [
                        "newArrival"
                    ]
                }
            ]
        },
        excludeLabels: [
            "NEW_ARRIVAL"
        ]
    },
    topRated: {
        metadata: {
            placement: "Top rated"
        },
        input: {
            sort: "RATING_DESC"
        },
        excludeLabels: []
    }
});
const ProductFeed = (props)=>{
    const { className, productsContainerClassName, feed, type, title, id, limit = 12, stickyFooterTriggerRef, withNotification, withUpgradeFlow, availableForQueue = true, productIdsToExclude, "data-testid": dataTestId } = props;
    const { isMobile } = (0,device__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    const { gender } = (0,modules_user__WEBPACK_IMPORTED_MODULE_3__/* .useUser */ .aF)();
    const [ref, entry] = (0,intersection_observer__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        once: true,
        observerProps: {
            rootMargin: "50%"
        }
    });
    const skip = !(entry === null || entry === void 0 ? void 0 : entry.isIntersecting);
    const { input, metadata, excludeLabels } = feedConfig[feed];
    const catalogueName = gender === "MALE" ? "colognes" : "perfumes";
    const { catalogueId, isFetching: isFetchingCatalogue } = (0,modules_products__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        catalogueName,
        skip
    });
    const { data, isFetching: isFetchingProducts } = (0,modules_products__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        variables: {
            id: catalogueId,
            input: {
                limit,
                availableForQueue,
                ...input
            }
        },
        ssr: false,
        skip: skip || !catalogueId
    });
    const products = (data === null || data === void 0 ? void 0 : data.products) || [];
    const filteredProducts = (productIdsToExclude === null || productIdsToExclude === void 0 ? void 0 : productIdsToExclude.length) > 0 ? products.filter((product)=>!productIdsToExclude.includes(product.id)) : products;
    const titleStyle = props.titleStyle || (isMobile ? "h5" : "h4");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        id: id,
        className: className,
        ref: ref,
        "data-testid": dataTestId,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_dataDisplay__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
                className: "mb-32 text-center",
                message: title,
                style: titleStyle,
                html: true
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                ref: stickyFooterTriggerRef
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(compositions_productLists_ProductCarousel_ProductCarousel__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                className: productsContainerClassName,
                desktopType: type,
                products: filteredProducts,
                isFetching: isFetchingCatalogue || isFetchingProducts,
                metadata: metadata,
                excludeLabels: excludeLabels,
                buttonProps: {
                    metadata,
                    withNotification,
                    withUpgradeFlow
                },
                withoutLink: true
            })
        ]
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.memo(ProductFeed));


/***/ }),

/***/ 17294:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var analytics__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(95812);
/* harmony import */ var components_layout__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59343);
/* harmony import */ var components_dataDisplay__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42692);
/* harmony import */ var components_inputs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(30468);
/* harmony import */ var _ProductCarousel_ProductCarousel__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(12360);







const ProductSmallCarouselSection = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)((props, ref)=>{
    const { className, title, supTitle, viewAllLink, viewAllTitle, viewAllStyle = "secondary", products, metadata, excludeLabels, isFetching, "data-testid": dataTestId, lazy } = props;
    if (!isFetching && !(products === null || products === void 0 ? void 0 : products.length)) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_layout__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        ref: ref,
        className: className,
        "data-testid": dataTestId,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_dataDisplay__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                supTitle: supTitle,
                title: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ProductCarousel_ProductCarousel__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                products: products,
                excludeLabels: excludeLabels,
                metadata: metadata,
                isFetching: isFetching,
                lazy: lazy
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "mt-32 text-center",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_inputs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    to: viewAllLink,
                    title: viewAllTitle,
                    size: 56,
                    width: 320,
                    style: viewAllStyle,
                    fullWidthOnMobile: true,
                    onClick: ()=>{
                        (0,analytics__WEBPACK_IMPORTED_MODULE_6__/* .track */ .j)("Show more products click", {
                            placement: metadata.placement
                        });
                    },
                    "data-testid": "viewAll"
                })
            })
        ]
    });
});
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.memo(ProductSmallCarouselSection));


/***/ }),

/***/ 11802:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var analytics__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(95812);
/* harmony import */ var device__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96934);
/* harmony import */ var intersection_observer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34886);
/* harmony import */ var modules_recommendations__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(55731);
/* harmony import */ var components_dataDisplay__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(78565);
/* harmony import */ var compositions_productLists_ProductCarousel_ProductCarousel__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(12360);








const RecommendationsFeed = (props)=>{
    const { className, productsContainerClassName, title, limit = 12, type, withNotification, withUpgradeFlow, productIdsToExclude } = props;
    const { isMobile } = (0,device__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    const [ref, entry] = (0,intersection_observer__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        once: true,
        observerProps: {
            rootMargin: "50%"
        }
    });
    const skip = !(entry === null || entry === void 0 ? void 0 : entry.isIntersecting);
    const { quizRecommendations, isFetching } = (0,modules_recommendations__WEBPACK_IMPORTED_MODULE_4__/* .useDiscoveryQuizResult */ .W)({
        profileRecommendationInput: {
            limit,
            placement: "Thank you page"
        },
        ssr: false,
        skip
    });
    const { recommenderName } = quizRecommendations || {};
    const products = (quizRecommendations === null || quizRecommendations === void 0 ? void 0 : quizRecommendations.products) || [];
    const filteredProducts = (productIdsToExclude === null || productIdsToExclude === void 0 ? void 0 : productIdsToExclude.length) > 0 ? products.filter((product)=>!productIdsToExclude.includes(product.id)) : products;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (!recommenderName) {
            return;
        }
        (0,analytics__WEBPACK_IMPORTED_MODULE_5__/* .track */ .j)("Recommendations display", {
            recommenderName
        });
    }, [
        recommenderName
    ]);
    const titleStyle = props.titleStyle || (isMobile ? "h5" : "h4");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: className,
        ref: ref,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_dataDisplay__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP, {
                className: "mb-32 text-center",
                message: title,
                style: titleStyle,
                html: true
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(compositions_productLists_ProductCarousel_ProductCarousel__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                className: productsContainerClassName,
                desktopType: type,
                products: filteredProducts,
                isFetching: isFetching,
                withoutLink: true,
                buttonProps: {
                    metadata: {
                        placement: "Quiz recommendations",
                        recommenderName
                    },
                    withNotification,
                    withUpgradeFlow
                }
            })
        ]
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (RecommendationsFeed);


/***/ })

}]);